import { set } from 'lodash';
import * as z from 'zod';
import * as ba from './base';
export class RegisterAction extends ba.Action {
    static get manifest() {
        return {
            name: 'register',
            schema: z.object({
                name: z.string(),
                value: z.string()
            })
        };
    }
    async handle(event, args) {
        set(event.data, args.name, args.value);
    }
}
//# sourceMappingURL=register.js.map